import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate} from "react-router-dom";
import Cookie from "js-cookie";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {
    Button,
    Card,
    Col,
    Empty,
    Flex,
    Form,
    Input,
    message,
    Modal,
    Row,
    Space,
    Spin,
    Switch,
    Tabs,
    Tag,
    Typography,
} from "antd";
import {DeleteOutlined, EditOutlined, PlusOutlined} from "@ant-design/icons";

const {Text, Title} = Typography;

const KEY_TAB_DEFS = [
    {key: '0', keyType: 'alt_top_num_r', label: '顶部 Alt + 数字'},
    {key: '1', keyType: 'alt_num_r', label: 'Alt + 数字'},
    {key: '2', keyType: 'ctrl_shift_abc', label: 'Ctrl + Shift + 字母'},
    {key: '3', keyType: 'shift_abc', label: 'Shift + 字母'},
] as const;

type KeyclickRow = {
    id: string;
    uuid: string;
    sort: string;
    keyname: string;
    mage1: string;
    mage2: string;
    key_type: string;
    key_value: {
        id: string;
        uuid: string | null;
        sort: string;
        keyname: string;
        key_type: string;
        mage1: string;
        mage2: string;
        status: string;
        [k: string]: unknown;
    } | null;
    [k: string]: unknown;
};

const Employeemanage_keyclick = () => {

    const navigate = useNavigate();
    let data_time = dayjs().unix();

    useEffect(() => {
        document.title = '快捷键管理 · 员工端';
    }, []);
    const cookiecheck = () => {


        if (Cookie.get('userToken_chattool') !== null) {


        } else {

            navigate('/login');

        }


    }

    useEffect(() => {

        window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部



        setfetch_keyclick_select_log({message: 'click', value: '', time: data_time})

    }, []);


    const [fetch_keyclick_select_info, setfetch_keyclick_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_keyclick_select_log, setfetch_keyclick_select_log] = useState({message: '', value: '', time: 0})
    const fetch_keyclick = (e1: any) => {

        setfetch_keyclick_select_log({message: 'click', value: '', time: data_time})


        setfetch_keyclick_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_keyclick, setreturn_data_fetch_keyclick] = useState<{
        message: number;
        value?: string;
        info: KeyclickRow[];
    }>({
        message: 0,
        value: '',
        info: [],
    });

    const [listLoading, setListLoading] = useState(true);

    useEffect(() => {
        if (fetch_keyclick_select_log.message === '') {
            return;
        }

        const selectId = fetch_keyclick_select_info.value1;
        const selectTime = fetch_keyclick_select_info.time;

        setListLoading(true);

        const data_async = async () => {
            const body = new FormData();
            body.append('id', selectId);
            body.append('userToken', String(Cookies.get('userToken_chattool')));
            body.append('time', String(selectTime));
            body.append('action', 'fetch_node');

            try {
                const data_await = await fetch(
                    'https://api.chatv2.leytcn.com/admin/keyclick/fetch/fetch_keyclick.php',
                    {method: 'POST', body}
                );

                const text = await data_await.text();
                let return_data: {message?: number; value?: string; info?: KeyclickRow[]};
                try {
                    return_data = JSON.parse(text) as typeof return_data;
                } catch {
                    message.error('服务器返回格式异常，请稍后重试');
                    return;
                }

                switch (return_data.message) {
                    case 2000:
                        setreturn_data_fetch_keyclick({
                            message: return_data.message ?? 0,
                            value: return_data.value,
                            info: Array.isArray(return_data.info) ? return_data.info : [],
                        });
                        break;
                    case 2001:
                        message.error(return_data.value);
                        break;
                    case 4018:
                        setTimeout(() => {
                            message.error(return_data.value);
                        }, 300);
                        navigate('/login?return_url=/employeemanage/keyclick');
                        break;
                    case 4019:
                        setTimeout(() => {
                            message.error(return_data.value);
                        }, 300);
                        navigate('/login?return_url=/employeemanage/keyclick');
                        break;
                    default:
                        message.error(return_data.value || '加载失败');
                        break;
                }
            } catch {
                message.error('网络异常，请检查连接后重试');
            } finally {
                setListLoading(false);
            }
        };

        void data_async();
        setfetch_keyclick_select_log({message: '', value: '', time: 0});
        // 与触发本次请求的 log 同一渲染周期内的 select_info 一并使用（勿把 select_info 加入 deps，否则会多触发）
    }, [fetch_keyclick_select_log]);


    const [edit_keyclick_info_modal_open, setedit_keyclick_info_modal_open] = useState(false)

    const [edit_keyclick_info_select_info, setedit_keyclick_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [edit_keyclick_info_select_log, setedit_keyclick_info_select_log] = useState({message: '', value: '', time: 0})
    const edit_keyclick_info = (e1: any, mage1: any, mage2: any) => {


        edit_keyclick_info_modal_form.setFieldValue('input_value1', mage1)

        edit_keyclick_info_modal_form.setFieldValue('input_value2', mage2)

        setedit_keyclick_info_select_log({message: 'click', value: '', time: data_time})

        setedit_keyclick_info_modal_open(true);

        setedit_keyclick_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setedit_keyclick_info_modal_oncancel = () => {

        setedit_keyclick_info_modal_open(false);
    }


    const [edit_keyclick_info_modal_form] = Form.useForm();

    const edit_keyclick_info_modal_initialValues = {}

    const [edit_keyclick_info_modal_onfinish_select_log, setedit_keyclick_info_modal_onfinish_select_log] = useState({message: '', value: '', time: 0})

    const [edit_keyclick_info_modal_onfinish_select_info, setedit_keyclick_info_modal_onfinish_select_info] = useState({value1: '', value2: '', value3: '', time: 0});

    const edit_keyclick_info_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setedit_keyclick_info_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setedit_keyclick_info_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_edit_keyclick_info, setreturn_data_edit_keyclick_info] = useState({});

    const edit_keyclick_info_body = new FormData();

    edit_keyclick_info_body.append('uuid', edit_keyclick_info_select_info.value1);

    edit_keyclick_info_body.append('finish_data', JSON.stringify(edit_keyclick_info_modal_onfinish_select_info.value1));

    edit_keyclick_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    edit_keyclick_info_body.append('time', String(edit_keyclick_info_modal_onfinish_select_info.time));

    edit_keyclick_info_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/keyclick/update/edit_keyclick_info.php', {


                method: 'POST',
                body: edit_keyclick_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setedit_keyclick_info_modal_open(false)

                    setreturn_data_edit_keyclick_info(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_keyclick_select_log({message: 'dd', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/employeemanage/keyclick')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/employeemanage/keyclick')


                    break


            }

        }


        if (edit_keyclick_info_modal_onfinish_select_log.message !== '') {

            data_async();
            setedit_keyclick_info_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [edit_keyclick_info_modal_onfinish_select_log]);


    const [add_keyclick_modal_open, setadd_keyclick_modal_open] = useState(false)

    const [add_keyclick_select_info, setadd_keyclick_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [add_keyclick_select_log, setadd_keyclick_select_log] = useState({message: '', value: '', time: 0})
    const add_keyclick = (e1: any, e2: any) => {

        setadd_keyclick_select_log({message: 'click', value: '', time: data_time})

        setadd_keyclick_modal_open(true);

        setadd_keyclick_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setadd_keyclick_modal_oncancel = () => {

        setadd_keyclick_modal_open(false);
    }


    const [add_keyclick_modal_form] = Form.useForm();

    const add_keyclick_modal_initialValues = {}

    const [add_keyclick_modal_onfinish_select_log, setadd_keyclick_modal_onfinish_select_log] = useState({message: '', value: '', time: 0})

    const [add_keyclick_modal_onfinish_select_info, setadd_keyclick_modal_onfinish_select_info] = useState({value1: '', value2: '', value3: '', time: 0});

    const add_keyclick_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setadd_keyclick_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setadd_keyclick_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_add_keyclick, setreturn_data_add_keyclick] = useState({});

    const add_keyclick_body = new FormData();

    add_keyclick_body.append('uuid', add_keyclick_select_info.value1);

    add_keyclick_body.append('finish_data', JSON.stringify(add_keyclick_modal_onfinish_select_info.value1));

    add_keyclick_body.append('userToken', String(Cookies.get('userToken_chattool')));

    add_keyclick_body.append('time', String(add_keyclick_modal_onfinish_select_info.time));

    add_keyclick_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/keyclick/insert/insert_keyclick_info.php', {


                method: 'POST',
                body: add_keyclick_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setadd_keyclick_modal_open(false)

                    setreturn_data_add_keyclick(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_keyclick_select_log({message: 'dd', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/employeemanage/keyclick')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/employeemanage/keyclick')


                    break


            }

        }


        if (add_keyclick_modal_onfinish_select_log.message !== '') {

            data_async();
            setadd_keyclick_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [add_keyclick_modal_onfinish_select_log]);






    const [update_switch_keynm_value_status_select_info, setupdate_switch_keynm_value_status_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [update_switch_keynm_value_status_select_log, setupdate_switch_keynm_value_status_select_log] = useState({message: '', value: '', time: 0})
    const update_switch_keynm_value_status = (e1: any) => {

        setupdate_switch_keynm_value_status_select_log({message: 'click', value: '', time: data_time})



        setupdate_switch_keynm_value_status_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_update_switch_keynm_value_status,setreturn_data_update_switch_keynm_value_status]=useState({});

    const update_switch_keynm_value_status_body = new FormData();


    update_switch_keynm_value_status_body.append('uuid', update_switch_keynm_value_status_select_info.value1);

    update_switch_keynm_value_status_body.append('name', update_switch_keynm_value_status_select_info.value2);
    update_switch_keynm_value_status_body.append('update_status', update_switch_keynm_value_status_select_info.value3);

    update_switch_keynm_value_status_body.append('userToken', String(Cookies.get('userToken_chattool')));

    update_switch_keynm_value_status_body.append('time', String(update_switch_keynm_value_status_select_info.time));

    update_switch_keynm_value_status_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/keyclick/update/update_keyclick_info_status.php', {


                method: 'POST',
                body: update_switch_keynm_value_status_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_update_switch_keynm_value_status(return_data);

                    setfetch_keyclick_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/employeemanage/keyclick')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/employeemanage/keyclick')


                    break


            }

        }


        if(update_switch_keynm_value_status_select_log.message!==''){

            data_async();
            setupdate_switch_keynm_value_status_select_log({message:'',value:'',time:0})
        }
    }, [update_switch_keynm_value_status_select_log]);



    const change_switch_status=(uuid:any,keyname:any,e:any)=>{



        console.log({uuid:uuid,keyname:keyname,e:e})
        if (e){

            const data_v='en';
            setupdate_switch_keynm_value_status_select_info({value1: uuid, value2: keyname, value3: data_v, time: data_time})

        }else{
            const data_v='de';
            setupdate_switch_keynm_value_status_select_info({value1: uuid, value2: keyname, value3: data_v, time: data_time})



        }

        setupdate_switch_keynm_value_status_select_log({message: 'click', value: '', time: data_time})






    }




    const [del_keynm_value_modal_open, setdel_keynm_value_modal_open] = useState(false)

    const [del_keynm_value_select_info, setdel_keynm_value_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [del_keynm_value_select_log, setdel_keynm_value_select_log] = useState({message: '', value: '', time: 0})
    const del_keynm_value = (uuid:any, keyname:any) => {

        setdel_keynm_value_select_log({message: 'click', value: '', time: data_time})

        setdel_keynm_value_modal_open(true);

        setdel_keynm_value_select_info({value1: uuid, value2: keyname, value3: '', time: data_time})
    }


    const setdel_keynm_value_modal_oncancel = () => {

        setdel_keynm_value_modal_open(false);
    }


    const [del_keynm_value_modal_next_button_select_log,setdel_keynm_value_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const del_keynm_value_modal_next_button = () => {

        let data_time=dayjs().unix();

        setdel_keynm_value_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_del_keynm_value,setreturn_data_del_keynm_value]=useState({});

    const del_keynm_value_body = new FormData();


    del_keynm_value_body.append('uuid', del_keynm_value_select_info.value1);


    del_keynm_value_body.append('name', del_keynm_value_select_info.value2);
    del_keynm_value_body.append('userToken', String(Cookies.get('userToken_chattool')));

    del_keynm_value_body.append('time', String(del_keynm_value_modal_next_button_select_log.time));

    del_keynm_value_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/keyclick/delete/delete_keyclick_info.php', {


                method: 'POST',
                body: del_keynm_value_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setdel_keynm_value_modal_open(false)

                    setreturn_data_del_keynm_value(return_data);
                    setfetch_keyclick_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/employeemanage/keyclick')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/employeemanage/keyclick')


                    break

            }

        }


        if(del_keynm_value_modal_next_button_select_log.message!==''){

            data_async();
            setdel_keynm_value_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [del_keynm_value_modal_next_button_select_log]);

    function renderKeyCard(item1: KeyclickRow) {
        const kv = item1.key_value;
        if (kv) {
            const enabled = kv.status === 'en';
            return (
                <Card
                    bordered
                    style={{borderRadius: 12, borderColor: '#f0f0f0'}}
                    styles={{body: {padding: 16}}}
                    title={
                        <Text code copyable style={{fontSize: 14}}>
                            {item1.keyname}
                        </Text>
                    }
                    extra={
                        <Space size={6} align="center" wrap>
                            <Tag color={enabled ? 'success' : 'default'}>{enabled ? '已启用' : '已关闭'}</Tag>
                            <Switch
                                size="small"
                                checked={enabled}
                                onChange={(checked) =>
                                    change_switch_status(kv.uuid, kv.keyname, checked)
                                }
                            />
                        </Space>
                    }
                >
                    <Space direction="vertical" size="middle" style={{width: '100%'}}>
                        <div>
                            <Text type="secondary" style={{fontSize: 12}}>回复一</Text>
                            <div style={{marginTop: 4}}>{kv.mage1 || ''}</div>
                        </div>
                        <div>
                            <Text type="secondary" style={{fontSize: 12}}>回复二</Text>
                            <div style={{marginTop: 4}}>{kv.mage2 || ''}</div>
                        </div>
                        <Flex gap="small" wrap="wrap" style={{marginTop: 4}}>
                            <Button
                                type="primary"
                                ghost
                                size="small"
                                icon={<EditOutlined/>}
                                onClick={() => edit_keyclick_info(kv.uuid, kv.mage1, kv.mage2)}
                            >
                                编辑
                            </Button>
                            <Button
                                danger
                                type="default"
                                size="small"
                                icon={<DeleteOutlined/>}
                                onClick={() => del_keynm_value(kv.uuid, kv.keyname)}
                            >
                                删除
                            </Button>
                        </Flex>
                    </Space>
                </Card>
            );
        }

        return (
            <Card
                bordered
                style={{borderRadius: 12, borderColor: '#f0f0f0', height: '100%'}}
                styles={{body: {padding: 16}}}
                title={
                    <Text code style={{fontSize: 14}}>
                        {item1.keyname}
                    </Text>
                }
            >
                <Text type="secondary" style={{display: 'block', marginBottom: 12}}>
                    尚未配置回复内容
                </Text>
                <Button
                    icon={<PlusOutlined/>}
                    onClick={() => add_keyclick(item1.uuid, item1.key_value)}
                >
                    立即配置
                </Button>
            </Card>
        );
    }

    const tabItems = useMemo(() => {
        return KEY_TAB_DEFS.map(({key, keyType, label}) => {
            const ok = return_data_fetch_keyclick.message === 2000;
            const list = ok
                ? return_data_fetch_keyclick.info.filter((row) => row.key_type === keyType)
                : [];

            const body = !ok ? (
                <Empty description="数据加载失败或未登录，请刷新页面或重新登录"/>
            ) : list.length === 0 ? (
                <Empty description="该分类下暂无快捷键位"/>
            ) : (
                <Row gutter={[16, 16]}>
                    {list.map((item1) => (
                        <Col xs={24} sm={24} md={12} xl={8} key={`${keyType}-${item1.id}`}>
                            {renderKeyCard(item1)}
                        </Col>
                    ))}
                </Row>
            );

            return {
                key,
                label,
                children: body,
            };
        });
        // renderKeyCard 随父组件每次渲染更新，数据变化由 return_data_fetch_keyclick 体现即可
    }, [return_data_fetch_keyclick]);

    return (<div style={{maxWidth: 1400, margin: '0 auto'}}>

        <Space direction="vertical" size="large" style={{width: '100%'}}>
            <div>
                <Title level={4} style={{margin: 0}}>快捷键回复</Title>
                <Text type="secondary" style={{display: 'block', marginTop: 6}}>
                    按快捷键类型管理自动回复；开启开关后客户端才会使用该键位。
                </Text>
            </div>

            <Card
                bordered={false}
                style={{
                    borderRadius: 12,
                    boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
                }}
                styles={{body: {padding: '8px 16px 16px'}}}
            >
                <Spin spinning={listLoading} tip="加载中..." delay={200}>
                    <Tabs
                        defaultActiveKey="0"
                        items={tabItems}
                        tabBarStyle={{marginBottom: 8}}
                    />
                </Spin>
            </Card>
        </Space>


        <Modal
            title="编辑快捷键回复"
            open={edit_keyclick_info_modal_open}
            onCancel={setedit_keyclick_info_modal_oncancel}
            footer={null}
            destroyOnClose
            width={520}
        >
            <Form
                form={edit_keyclick_info_modal_form}
                layout="vertical"
                initialValues={edit_keyclick_info_modal_initialValues}
                onFinish={edit_keyclick_info_modal_onfinish}
                style={{marginTop: 8}}
            >
                <Form.Item label="回复一" name="input_value1" rules={[{message: '请输入回复一', required: true}]}>
                    <Input.TextArea rows={3} placeholder="发送的第一条内容" allowClear showCount maxLength={500}/>
                </Form.Item>
                <Form.Item label="回复二" name="input_value2">
                    <Input.TextArea rows={3} placeholder="发送的第二条内容（选填）" allowClear showCount maxLength={500}/>
                </Form.Item>
                <Form.Item style={{marginBottom: 0}}>
                    <Space>
                        <Button type="primary" htmlType="submit">保存</Button>
                        <Button onClick={setedit_keyclick_info_modal_oncancel}>取消</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>

        <Modal
            title="删除快捷键配置"
            open={del_keynm_value_modal_open}
            onCancel={setdel_keynm_value_modal_oncancel}
            footer={null}
            destroyOnClose
            width={400}
        >
            <Text type="secondary" style={{display: 'block', marginBottom: 16}}>删除后该键位将恢复为未配置状态，确定继续？</Text>
            <Space>
                <Button danger type="primary" icon={<DeleteOutlined/>} onClick={del_keynm_value_modal_next_button}>
                    确认删除
                </Button>
                <Button onClick={setdel_keynm_value_modal_oncancel}>取消</Button>
            </Space>
        </Modal>

        <Modal
            title="添加回复内容"
            open={add_keyclick_modal_open}
            onCancel={setadd_keyclick_modal_oncancel}
            footer={null}
            destroyOnClose
            width={520}
        >
            <Form
                form={add_keyclick_modal_form}
                layout="vertical"
                initialValues={add_keyclick_modal_initialValues}
                onFinish={add_keyclick_modal_onfinish}
                style={{marginTop: 8}}
            >
                <Form.Item label="回复一" name="input_value1" rules={[{message: '请输入回复一', required: true}]}>
                    <Input.TextArea rows={3} placeholder="发送的第一条内容" allowClear showCount maxLength={500}/>
                </Form.Item>
                <Form.Item
                    label="回复二"
                    name="input_value2"
                    rules={[{message: '请输入回复二', required: true}]}
                >
                    <Input.TextArea rows={3} placeholder="发送的第二条内容" allowClear showCount maxLength={500}/>
                </Form.Item>
                <Form.Item style={{marginBottom: 0}}>
                    <Space>
                        <Button type="primary" htmlType="submit">保存</Button>
                        <Button onClick={setadd_keyclick_modal_oncancel}>取消</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>









    </div>)
}

export default Employeemanage_keyclick;
